import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import qs from 'query-string';
import compose from 'recompose/compose';

import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      color: theme.palette.secondary.main,
      fontWeight: '700',
      height: '20px',
    },
  };
};

class TableHeadCell extends PureComponent {
  static propTypes = {
    sortByKey: PropTypes.string,
    TableSortLabelProps: PropTypes.object,
    children: PropTypes.node,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  /**
   * Pushes the correct queryString on to the URL.
   */
  orderBy = key => {
    const { history } = this.props;
    const query = qs.parse(history.location.search);

    const setToAsc = query.sortDirection === 'desc' ? 'asc' : 'desc';
    query.sortDirection = query.sortBy === key ? setToAsc : 'desc';
    query.sortBy = key;

    if (query.page) {
      delete query.page;
    }

    history.push(`${history.location.pathname}?${qs.stringify(query)}`);
  };

  render() {
    const {
      sortByKey,
      classes,
      children,
      TableSortLabelProps,
      history,
      location,
      match,
      staticContext, // eslint-disable-line
      ...otherProps
    } = this.props;
    const query = qs.parse(history.location.search);

    const LabelComponent = sortByKey && query ? TableSortLabel : 'span';
    const labelComponentProps = {};
    if (sortByKey && query) {
      labelComponentProps.active = query.sortBy === sortByKey;
      labelComponentProps.direction = query.sortDirection;
      labelComponentProps.onClick = () => this.orderBy(sortByKey);
    }

    return (
      <TableCell
        className={classes.root}
        sortDirection={query ? (query.sortBy === sortByKey ? query.sortDirection : false) : null}
        {...otherProps}
      >
        <LabelComponent {...labelComponentProps}>{children}</LabelComponent>
      </TableCell>
    );
  }
}

export default compose(withRouter, withStyles(styles))(TableHeadCell);
